import api from '../api';

import { ParamsDataUsefulContacts } from 'utils/typeServices';

type ParamsReponse = {
    Data: ParamsDataUsefulContacts;
}

export const GetUsefulContacts = async ({ token }: { token: string }) => {
    try {
        const { data } = await api.get<ParamsReponse>('/v1/Plataforma/UsefulContacts', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
